import { getInvitesCardState } from '../selectors/dashboard/InvitesCard';
import { getSaveTheDateCardState } from '../selectors/dashboard/SaveTheDateCard';
import { getAllStorage, setAllStorage } from './storage';
import { userCreatedAfter } from './trackingHelper';
// optimizelyHelper expects an optimizely config like so:
// const optimizelyConfig = {
//   // Staging
//   554664308: {
//     pageName: '554664308_url_targeting_for_perfect_registry_onboarding',
//     experimentId: '12109791999',
//     variationId: '12091993637'
//   },
//   // Production
//   566520915: {
//     pageName: '566520915_url_targeting_for_perfect_registry_onboarding',
//     experimentId: '12115484653',
//     variationId: '12119022586'
//   }
// };

export default function inOptimizelyExperiment(optimizelyConfig, trackPageViewEvent = true) {
  if (window.optimizely && window.optimizely.get) {
    const optimizelyData = window.optimizely.get('data');
    const {
      pageName,
      experimentId,
      variationId
    } = optimizelyConfig[optimizelyData.projectId];
    window.optimizely = window.optimizely || [];

    if (trackPageViewEvent) {
      window.optimizely.push({
        type: 'page',
        pageName
      });
    }

    const state = window.optimizely.get('state');

    const allExperiments = state.getExperimentStates({ isActive: true });
    const experiment = allExperiments[experimentId];
    if (experiment && experiment.variation && experiment.variation.id === variationId) {
      return true;
    }
  }
  return false;
}

export const userHasNoRegistryOrCards = (store) => {
  const state = store.getState();
  const invitesCardState = getInvitesCardState(state);
  const saveTheDateCardState = getSaveTheDateCardState(state);
  const invitationsActivated = invitesCardState.activated || saveTheDateCardState.activated;
  const userContext = state && state.user && state.user.userContext;
  const hasRegistry = (userContext && userContext.registry_ids && userContext.registry_ids.length > 0) || false;
  return !(hasRegistry || invitationsActivated);
};

// Function for determining if a new user* should go to the experiment page component for a test.
//
// * New user defined as a user that doesn't have an activated registry, has no drafts, and
// has never see the wedding dashboard before the test began.
//
// Example params:
// const newDashboardTestProps = {
//   isOptimizelyTestSkipped: true,
//   devStart: '2019-01-25T16:00:00.000Z', // Dev - Friday at 11am EST, January 25th, 2019
//   prodStart: '2019-02-04T21:45:37.103Z', // Prod - Monday at 2:30pm EST, January 28th, 2019
//   cookieName: 'isNewUserWeddingPlanningDashboard',
//   optimizelyConfig: newWeddingPlanningDashConfig,
//   store,
// };

export const shouldGoToTestPage = ({ isOptimizelyTestSkipped, devStart, prodStart, cookieName, optimizelyConfig, store }) => {
  let isUserInTest = window.zola.env === 'development';
  const useOldTestDateForWeddingDash = window.zola.env === 'development' || window.zola.env === 'production';
  const testBeganAtStr = useOldTestDateForWeddingDash ? devStart : prodStart; // Dates are in ISO 8601 format E.G. 2019-02-04T19:10:37.103Z
  const userCreatedAfterTestBegan = userCreatedAfter(testBeganAtStr);
  const wasAlreadyNewUser = getAllStorage(cookieName) === 'true';
  const isNewUser = wasAlreadyNewUser || (userCreatedAfterTestBegan && userHasNoRegistryOrCards(store));

  if (!wasAlreadyNewUser && isNewUser) {
    setAllStorage(cookieName, 'true');
  }

  if (!isOptimizelyTestSkipped && isNewUser) {
    isUserInTest = inOptimizelyExperiment(optimizelyConfig);
  }

  return isUserInTest;
};



// WEBPACK FOOTER //
// ./src/util/optimizelyHelper.js